/*
 * @Author: 刘枫
 * @Date: 2021-01-07 09:47:33
 * @Last Modified by: mikey.zhaopeng
 * @titlt :首页快讯
 * @Last Modified time: 2021-05-26 12:10:38
 */
<template>
  <div class="right-sidebar">
    <div class="right-content">
      <div class="policy">
        <img src="//static.kxymall.com/images/CP.png" />
      </div>
      <div class="login-out" v-if="isLogin">
        <img :src="$store.getters.face" class="head-img">
        <h2>Hi~{{name}}</h2>
        <ul class="head-ul-orad">
          <li>
            <router-link class="p1" to="/member/order?status=5">{{waitconfirmCount}}</router-link>
            <p>待收货</p>
          </li>
          <li>
            <router-link class="p1" to="/member/order?status=2">{{waitrogCount}}</router-link>
            <p>待发货</p>
          </li>
          <li>
            <router-link class="p1" to="/member/order?status=0">{{notpayCount}}</router-link>
            <p>待付款</p>
          </li>
          <li>
            <router-link class="p1" to="/member/comments?tab=2">{{waitcommentCount}}</router-link>
            <p>待评价</p>
          </li>
        </ul>
      </div>
      <div class="login-out" v-else>
        <img src="//static.kxymall.com/images/default_face.jpg" class="head-img">
        <h2>Hi~欢迎来逛逛</h2>
        <router-link class="button" to="/login" title="会员登录">登录</router-link>
        <router-link class="button" to="/register" title="会员注册">注册</router-link>
      </div>
      <div class="mall-news">
        <div class="title">开心云商快讯</div>
        <ul class="mall-news">
          <li v-for="(item,index) in list" :key="item.id">
            <span class="mall-news-tips">推荐</span>
            <router-link :to="{path:'/help',query:{articleid:item.id,new:1}}" :title="item.page_title"
              class="mall-new-li" target="_blank">
              {{item.page_title}}
            </router-link>
            <!-- <time>{{item.add_time}}</time> -->
          </li>
        </ul>
      </div>
      <div class="a" v-for="(item, index) in advList" v-if="advList.length>0 && index < 2" :key="item.key">
        <a :href="item.url" target="_blank" :title="item.aname">
          <img :src="item.atturl" :alt="item.aname" width="100%" height="97px" />
        </a>
      </div>
      <!--<div class="a">
        <router-link to="/goods-list?vouchers_status=2" title="爆款专区">
          <img :src="adv01" width="186px" height="90px"/>
        </router-link>
      </div>
      <div class="a">
        <router-link to="/goods-boutique" title="精品专区">
          <img :src="adv02" width="186px" height="90px"/>
        </router-link>
      </div>
      <div class="a">
        <router-link to="/supply-chain-list" title="直供专区">
          <img :src="adv03" width="186px" height="90px"/>
        </router-link>
      </div>-->

    </div>
  </div>
</template>
<script>
import adv01 from '../../../assets/images/adv01.jpg';
import adv02 from '../../../assets/images/adv02.jpg';
import adv03 from '../../../assets/images/adv03.jpg';
import { formatDate, parseAdvList } from 'utils/tool';
import { getOrderCount } from "api/order";
import { mapGetters } from 'vuex';
export default {
  props: ['data', 'adv'],
  data() {
    let list = this.data.map(item => {
      let _item = item;
      _item.add_time = formatDate(item.add_time);
      return _item;
    });
    let advList = this.adv.advList;
    return {
      list,
      advList,
      adv01,
      adv02,
      adv03,
      isLogin: false,
      notpayCount: 0,//待支付
      waitrogCount: 0,//待发货
      waitconfirmCount: 0,//待收货
      waitcommentCount: 0//待评价
    }
  },
  computed: {
    ...mapGetters([
      'sid', 'name'
    ]),
  },
  watch: {
    '$route': function () {
      this.isLogin = localStorage.getItem('sid') == null ? false : true;
      if (this.isLogin) {
        this.getOrderCount()
      }
    }
  },
  created() {
    this.isLogin = localStorage.getItem('sid') == null ? false : true;
    if (this.isLogin) {
      this.getOrderCount()
    }
  },
  methods: {
    //登录刷新接口获取订单
    getOrderCount() {
      getOrderCount().then(res => {
        this.notpayCount = res.data.notpayCount
        this.waitrogCount = res.data.waitrogCount
        this.waitconfirmCount = res.data.waitconfirmCount
        this.waitcommentCount = res.data.waitcommentCount
      })
    }
  }
}
</script>
<style scoped>
@import "../../../assets/css/home-page/banner/flashNewsList.css";
/* .focus-warp .right-content {
  width: 212px;
  position: absolute;
  top: 0;
  right: 8px;
  z-index: 3;
  background: #fff;
  height: 520px;
  overflow: hidden;
  border: 1px solid #eee;
}

.mall-new-li {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  max-width: 154px;
  padding-left: 4px;
  vertical-align: top;
} */
</style>



// WEBPACK FOOTER //
// flashNewsList.vue?53f81baf